

/*
* custom
 */
window.flowUpLabel = function (selector) {
  $(selector).each(function () {
    if ($(this).val()) {
      $(this).parent('.fields-group').addClass('filled');
    } else {
      $(this).parent('.fields-group').removeClass('filled');
    }
  });
  $(selector).on('focusin', function () {
    if (!$(this).parent().hasClass('dropdown-group'))
      $(this).parent('.fields-group').addClass('focused');
  });
  $(selector).on('focusout change', function () {
    $(this).parent('.fields-group').removeClass('focused');
    if ($(this).val()) {
      $(this).parent('.fields-group').addClass('filled');
    } else {
      $(this).parent('.fields-group').removeClass('filled');
    }
  });
};

window.dropdownInput = function (selector) {
  $(selector).on('click', function (e) {
    console.log(e.target);
    if (!$(e.target).closest('ul').length) {
      $(this).toggleClass('open');
    }
    $(e.target).addClass('active').siblings('li').removeClass('active');
    $(e.target).closest(selector).children('.group-hidden-input').val($(e.target).data('value'));
    $(e.target).closest(selector).addClass('filled').children('.group-text-input').val($(e.target).text())
    if (!$(e.target).closest('li').length) {
      e.preventDefault()
    }

    if (!$(this).closest('.dropdown-group').hasClass('multiple-dropdown') && $(e.target).parent().hasClass('dropdown-input-list')) {
      $(this).closest('.dropdown-group').removeClass('open')
    }

    $(selector).find('input[type="checkbox"]').on('change', function () {
      $(this).closest(selector).next('.selected-dropdown-list').html('');
      $(this).closest(selector).find('input:checked').each(function () {
        $(this).closest(selector).next('.selected-dropdown-list').append('<label for="' + $(this).attr("id") + '">' + $(this).next().text() + '<svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px"><path fill-rule="evenodd" d="M8.991,8.001 L8.818,8.170 L16.005,15.193 L15.187,15.992 L8.000,8.969 L0.813,15.992 L-0.005,15.193 L7.182,8.170 L7.009,8.001 L7.182,7.831 L-0.005,0.808 L0.813,0.008 L8.000,7.032 L15.187,0.008 L16.005,0.808 L8.818,7.831 L8.991,8.001 Z"/></svg></label>')
      })
    });

  });
  $(document).on('mouseup', function (e) {
    if ($(e.target).closest('.open').length === 0) {
      $(selector).removeClass('open')
    }
  })
};

window.dateRangeFields = function (selector) {
  var startDateInput = $(selector).find('.date-from');
  var endDateInput = $(selector).find('.date-end');
  var year=$(selector).find('.set-year');
  var month=$(selector).find('.set-month');
  var maskOption = {
    mask: '99.99.9999',
    greedy: false,
    placeholder: '',
    showMaskOnHover: false,
    showMaskOnFocus: false
  };
  startDateInput
    .inputmask(maskOption)
    .datepicker({
      showOtherMonths: false,
      dateFormat: 'dd.mm.yyyy',
      classes: 'events-calendar'
    });
  endDateInput
    .inputmask(maskOption)
    .datepicker({
      showOtherMonths: false,
      dateFormat: 'dd.mm.yyyy',
      classes: 'events-calendar'
    });
  year.datepicker({
    view: 'years',
    minView: 'years',
    showOtherYears: false,
    selectOtherYears: 'false',
    dateFormat: 'yyyy'
  });
  var today=new Date();
  month.datepicker({
    view: 'months',
    minView: 'months',
    showOtherYears: false,
    selectOtherYears: 'false',
    dateFormat: 'MM',
    minDate: new Date(today.getFullYear(),0,1),
    maxDate: new Date(today.getFullYear(),11,31),
    navTitles : {
      days: '',
      months: 'Выберите месяц',
      years: ''
    }
  });
};

window.sliderFields=function(selector){
  var label=$(selector).find('label');
  var labelText=label.html();
  label.html('<span>'+labelText+'</span>');
  var min=parseInt($(selector).find('.js-sliders').attr('data-min'));
  var max=parseInt($(selector).find('.js-sliders').attr('data-max'));
  checkTextOverflow(label.find('span'));
  $(selector).on('mouseenter',function(){
    "use strict";

    var left=label.width()-label.find('.scrolling').width()-40;
    if(!label.find('.scrolling').hasClass('animating')){
      label.find('.scrolling').animate({'left':left},4000,function(){});
    }
    label.find('.scrolling').addClass('animating');
  });
  $(selector).on('mouseleave',function(){
    "use strict";
    label.find('.scrolling').animate({'left':0},100,function(){
      label.find('.scrolling').removeClass('animating');
    })
  });
  $(selector).find('.js-sliders').slider({
    min: min,
    max: max,
    values: [min,max],
    range: true,
    stop: function(event, ui) {
      $(selector).find('[data-from]').val($(this).slider("values",0));
      $(selector).find('[data-to]').val($(this).slider("values",1));
      $(selector).find('[data-value]').val($(this).slider("values",0)+' - '+$(this).slider("values",1));
    },
    slide: function(event, ui){
      $(selector).find('[data-from]').val($(this).slider("values",0));
      $(selector).find('[data-to]').val($(this).slider("values",1));
      $(selector).find('[data-value]').val($(this).slider("values",0)+' - '+$(this).slider("values",1));
      $(selector).find('[data-value]').trigger('focus');
      $(selector).find('.js-sliders').addClass('active');
    }
  });


  if($(selector).find('[data-from]').val()){
    $(selector).find('.js-sliders').slider( "option", "values", [ $(selector).find('[data-from]').val(), $(selector).find('[data-to]').val()] );
    $(selector).find('.js-sliders').addClass('active');
    $(selector).find('[data-value]').trigger('focus');
    $(selector).find('[data-value]').val($(selector).find('[data-from]').val()+' - '+$(selector).find('[data-to]').val());
  }


  function checkTextOverflow(text){
    "use strict";
    if(text.width()>text.parent().width()){
      text.addClass('scrolling');
    }
  }

};

// inputs in filter
flowUpLabel('.group-text-input');
dropdownInput('.dropdown-group');
dateRangeFields('.date-group');

$('.js-sliders-group').each(function(){
  "use strict";
  sliderFields($(this));
});
window.requestFrame = (function () {
    return (window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback, element, delay) {
        window.setTimeout(callback, delay || (1000 / 60));
    });
})();

window.detectMob= function() {
    if( navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    ){
        return true;
    }
    else {
        return false;
    }
};

window.share = {
    vkontakte: function(purl, ptitle, pimg, text) {
        url  = 'http://vkontakte.ru/share.php?';
        url += 'url='          + encodeURIComponent(purl);
        url += '&title='       + encodeURIComponent(ptitle);
        url += '&description=' + encodeURIComponent(text);
        url += '&image='       + encodeURIComponent(pimg);
        url += '&noparse=true';
        share.popup(url);
    },
    odnoklassniki: function(purl, text) {
        url  = 'http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1';
        url += '&st.comments=' + encodeURIComponent(text);
        url += '&st._surl='    + encodeURIComponent(purl);
        share.popup(url);
    },
    facebook: function(purl, ptitle, pimg, text) {
        url  = 'http://www.facebook.com/sharer.php?s=100';
        url += '&p[title]='     + encodeURIComponent(ptitle);
        url += '&p[summary]='   + encodeURIComponent(text);
        url += '&p[url]='       + encodeURIComponent(purl);
        url += '&p[images][0]=' + encodeURIComponent(pimg);
        share.popup(url);
    },
    twitter: function(purl, ptitle) {
        url  = 'http://twitter.com/share?';
        url += 'text='      + encodeURIComponent(ptitle);
        url += '&url='      + encodeURIComponent(purl);
        url += '&counturl=' + encodeURIComponent(purl);
        share.popup(url);
    },
    mailru: function(purl, ptitle, pimg, text) {
        url  = 'http://connect.mail.ru/share?';
        url += 'url='          + encodeURIComponent(purl);
        url += '&title='       + encodeURIComponent(ptitle);
        url += '&description=' + encodeURIComponent(text);
        url += '&imageurl='    + encodeURIComponent(pimg);
        share.popup(url)
    },

    popup: function(url) {
        window.open(url,'','toolbar=0,status=0,width=626,height=436');
    }
};

window.getDeviceWidth = function() {
  return (window.innerWidth > 0) ? window.innerWidth : screen.width
};

window.seeMoreLink = function (blockSelector, height, text) {
  var bloks_total = $(blockSelector);
  if(bloks_total.length){
    for(var i=0; i < bloks_total.length; i++){
      var block_height = Number($(bloks_total[i]).css('height').replace('px',''));

      $(bloks_total[i]).after('<a class="read-more" href="#" style="display: none">' + text + '</a>');

      if(block_height > height){
        $(bloks_total[i]).css('max-height', height + 'vh');
        $(bloks_total[i]).next('.read-more').show();
      }
    }
  }

  $(document).on('click', '.read-more', function(){
    var block = $(this).prev(blockSelector);
    if(block.css('max-height') != 'none'){
      block.css('max-height','');
      $(this).text('Скрыть');
    } else {
      block.css('max-height', height + 'vh');
      $(this).text(text);
    }
    return false;
  });
};

(function($){
    "use strict";
    $('.top-menu a.search').on('click',function(){
        var $input=$(this).closest('.top-menu').find('.search-form input');
        if(!$input.val()){
            $input.focus();
        } else {
            $(this).closest('.top-menu').find('.search-form form').submit();
        }
    });

})($);

// slick-slider for circle items
(function($){
    "use strict";

    if(!$('.index-city-num-items').length){
        $('.circle-items-section .section-list-wrap').slick({
            responsive: [
                {
                    breakpoint: 9999,
                    settings: "unslick"
                },
                {
                    breakpoint: 767,
                    settings: {
                        dots: false,
                        arrows: false,
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    initMainNumsBlock();
    

    function initMainNumsBlock(){
        $('.index-city-num-items .section-list-wrap').slick({
            responsive: [
                {
                    breakpoint: 9999,
                    settings: "unslick"
                },
                {
                    breakpoint: 1602,
                    settings: {
                        dots: false,
                        arrows: true,
                        infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 1201,
                    settings: {
                        dots: false,
                        arrows: true,
                        infinite: true,
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        dots: false,
                        arrows: true,
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $('.izb .index-city-num-items .section-list-wrap').slick({
            responsive: [
                {
                    breakpoint: 9999,
                    settings: {
                        dots: false,
                        arrows: true,
                        infinite: true,
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 1602,
                    settings: {
                        dots: false,
                        arrows: true,
                        infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 1201,
                    settings: {
                        dots: false,
                        arrows: true,
                        infinite: true,
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        dots: false,
                        arrows: true,
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }




})($);

(function($){
    "use strict";
    $('[data-usefull-links-slider]').slick({
        responsive: [
            {
                breakpoint: 9999,
                settings: {
                    dots: false,
                    arrows: true,
                    infinite: true,
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 1601,
                settings: {
                    dots: false,
                    arrows: true,
                    infinite: true,
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 1201,
                settings: {
                    dots: false,
                    arrows: true,
                    infinite: true,
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    dots: false,
                    arrows: true,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    


})($);

if ($('.document-content-text').length) {
  seeMoreLink('.document-content-text', 61, 'Показать полностью');
}

if ($('.person-card-information-list').length) {
  seeMoreLink('.person-card-information-list', 0, 'Подробнее');
}

//$('<div class="under-construction">Извините, новый сайт работает не в полном режиме! Вы можете перейти на <a href="http://old.sochiadm.ru">прежнюю версию</a></div>').insertBefore('.header');
//$('body').addClass('dev');


outerLinks();

function outerLinks(){
    $('body').find('a').each(function () {
        var url=$(this).attr('href');
        if (String.prototype.startsWith){
            if(url){
                if(url.startsWith('http')){
                    $(this).attr('target','_blank');
                    $(this).addClass('red');
                }
            }
        }
    });
}

function setEqualHeight(columns)
{
    var tallestcolumn = 0;
    columns.each(
        function()
        {
            currentHeight = $(this).height();
            if(currentHeight > tallestcolumn)
            {
                tallestcolumn = currentHeight;
            }
        }
    );
    columns.height(tallestcolumn);
}

function setEqualHeightOdd(columns)
{
    var tallestcolumn = 0;
    var blocks=[];
    var colummNum=0;
    columns.each(
        function()
        {
                blocks.push($(this));
                currentHeight = $(this).height();
                if(currentHeight > tallestcolumn)
                {
                    tallestcolumn = currentHeight;
                }
            colummNum++;
            if(colummNum>1){
                colummNum=0;
                setHeight(blocks,tallestcolumn);
                tallestcolumn=0;
                blocks=[];
            }


        }
    );
    function setHeight(blocks,tallestcolumn){
        "use strict";
        for(var i=0;i<blocks.length;i++){
            blocks[i].height(tallestcolumn);
        }
    }
}

setEqualHeight($('.usefull-links-slider  .usefull-links-item'));
setEqualHeightOdd($('.photo-list-item'));
setEqualHeightOdd($('[data-set-height-odd]'));
setEqualHeight($('[data-set-height]'));
setEqualHeight($('[data-set-title-height]'));

var resizeTimer;

$(window).resize(function(){
    "use strict";
    clearTimeout(resizeTimer);
    resizeTimer=setTimeout(function(){
        $('.usefull-links-slider  .usefull-links-item ,[data-set-height] , [data-set-height-odd] ,[data-set-title-height] , .photo-list-item').attr('style','');
        setEqualHeight($('.usefull-links-slider  .usefull-links-item'));
        setEqualHeight($('[data-set-height]'));
        setEqualHeight($('[data-set-title-height]'));
        setEqualHeightOdd($('[data-set-height-odd]'));
        setEqualHeightOdd($('.photo-list-item'));
    },10);
});

function startAnimation(){
    "use strict";
    $('[data-animate]').each(function(){
        var position=$(this).position();
        if(pageYOffset>position.top-300){
            $(this).addClass('animation-play');
        }
    });
    requestFrame(startAnimation);
}

if($('[data-animate]').length){
    startAnimation();
}
var detailItemApp = function () {
  this.init();
};

detailItemApp.prototype = {
  init: function () {
    this.setParams();
    this.getVideoPreview();
    this.initModal();
    this.initSlider(this.mainSlider);
    this.setMapContent();
  },
  setParams: function () {
    this.videoItemSelector = '.video-item';
    this.mainBlock = $('.item-detail-content');
    this.mainSliderBlock = this.mainBlock.find('.detail-content-media-slider');
    this.mainSlider = this.mainSliderBlock.children('.media-content-list');
    this.mainModal = this.mainBlock.find('.item-detail-modal');
    this.activeSlide = 0;
  },
  getVideoPreview: function () {
    $(this.videoItemSelector).each(function () {
      // Зная идентификатор видео на YouTube, легко можно найти его миниатюру
      $(this).css('background-image', 'url(http://i.ytimg.com/vi/' + $(this).data('video') + '/sddefault.jpg)');
      // Добавляем иконку Play поверх миниатюры
      $(this).append($('<div/>', {'class': 'play'}));
    });
  },
  getYoutubeVideo: function (elem) {
    // создаем iframe со включенной опцией autoplay
    var iframe_url = "https://www.youtube.com/embed/" + elem.data('video') + "?autoplay=1&autohide=1";
    if (elem.data('params')) iframe_url += '&' + elem.data('params');

    // Высота и ширина iframe от родительского блока
    var iframe = $('<iframe/>', {
      'frameborder': '0',
      'src': iframe_url,
      'width': elem.width(),
      'height': elem.outerHeight(true)
    });
    // Заменяем миниатюру HTML5 плеером с YouTube
    elem.replaceWith(iframe);
  },
  setMapContent: function () {
    if ($('#map-event-content').length) {

      if(!window.ymaps){
        var yApi=document.createElement('script');
        yApi.type='text/javascript';
        document.body.appendChild(yApi);
        yApi.src='https://api-maps.yandex.ru/2.1/?lang=ru_RU';
        yApi.addEventListener('load',function(){
          "use strict";
          showMap();
        },false)
      } else {
        showMap();
      }

      function showMap(){
        ymaps.ready(function () {
          var lat = $('#map-event-content').data('lat');
          var lng = $('#map-event-content').data('lng');
          var myMap = new ymaps.Map('map-event-content', {
                center: [lat, lng],
                zoom: 16
                //controls: []
              },
              {});
          //myMap.behaviors.disable('scrollZoom');
          //myMap.behaviors.disable('drag');

          myPlacemark = new ymaps.Placemark(myMap.getCenter(), {
            hintContent: '',
            balloonContent: ''
          });

          myMap.geoObjects.add(myPlacemark);
        });
      }

    }
  },
  initSlider: function (sliderBlock) {

    var self = this;
    var nextArrow = sliderBlock.closest('.detail-content-media-slider').find('.next-link');
    var prevArrow = sliderBlock.closest('.detail-content-media-slider').find('.prev-link');
    sliderBlock.on('afterChange', function (event, slick, currentSlide, nextSlide) {
      self.activeSlide = currentSlide;
    });
    sliderBlock.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      var i = self.activeSlide + 1;
      $('.navigation-items-counter').html('<span class="current">' + i + '</span>/<span class="total">' + slick.slideCount + '</span>');
    });
    sliderBlock.slick({
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      appendArrows: sliderBlock,
      initialSlide: self.activeSlide,
      infinite: true,
      adaptiveHeight: true
    });

    $('body').removeClass('loading');

    sliderBlock.find('.image-item img').on('load',function(){
      "use strict";
      $(window).trigger('resize');
    });




  },
  initModal: function () {
    var self = this;
    var modalContent;
    var videoItem;
    var modalOptions = {
      modalClass: 'modal-transparent',
      showClose: false
    };
    var modalDynamicBlock = self.mainModal.find('.js-dynamic-content');
    self.mainSliderBlock.on('click', '.content-list-item', function (e) {
      if (getDeviceWidth() > 767) {
        self.mainSlider.slick('destroy');
        modalContent = self.mainSliderBlock.clone();
        self.initSlider(self.mainSlider);
        self.initSlider(modalContent.find('.media-content-list'));
        videoItem = modalContent.find('.video-item');
        videoItem.on('click', function () {
          self.getYoutubeVideo($(this))
        });
        if ($(e.target).hasClass('play')) {
          setTimeout(function () {
            self.getYoutubeVideo(self.mainModal.find('.slick-active').find('.video-item'))
          }, 100)
        }
        $.modal.close();
        self.mainModal.on($.modal.BEFORE_CLOSE, function(event, modal) {
          self.mainModal.find('.js-dynamic-content').html('');
        });

        $('.item-detail-content .detail-content-date').clone().appendTo(modalDynamicBlock);
        $('.item-detail-content .title').clone().appendTo(modalDynamicBlock);
        modalDynamicBlock.append(modalContent);
        self.mainModal.modal(modalOptions);
      } else {
        if ($(e.target).hasClass('play')) {
          self.getYoutubeVideo($(e.target).parent())
        }
      }

    })
  }
};
// item detail page
if($(document).find('.item-detail-content').length) {
  new detailItemApp();
} else if($('#map-event-content').length) {
    setMapLonelyContent();
}

 function setMapLonelyContent () {
  if ($('#map-event-content').length) {

    if(!window.ymaps){
      var yApi=document.createElement('script');
      yApi.type='text/javascript';
      document.body.appendChild(yApi);
      yApi.src='https://api-maps.yandex.ru/2.1/?lang=ru_RU';
      yApi.addEventListener('load',function(){
        "use strict";
        showMap();
      },false)
    } else {
      showMap();
    }

    function showMap(){
      ymaps.ready(function () {
        var lat = $('#map-event-content').data('lat');
        var lng = $('#map-event-content').data('lng');
        var myMap = new ymaps.Map('map-event-content', {
              center: [lat, lng],
              zoom: 16
              //controls: []
            },
            {});
        myMap.behaviors.disable('scrollZoom');
        //myMap.behaviors.disable('drag');

        myPlacemark = new ymaps.Placemark(myMap.getCenter(), {
          hintContent: '',
          balloonContent: ''
        });

        myMap.geoObjects.add(myPlacemark);
      });
    }

  }
}


//remove print styles

$('.close-modal').on('click',function(e){
  "use strict";
  e.stopPropagation();
  e.preventDefault();
  $('body').removeClass('print-only-ajax');
  $('.fade-modal').addClass('modal-hide');
  setTimeout(function(){
    "use strict";
    $('.fade-modal').removeClass('modal-hide');
    $.modal.close();
  },500);
});
var fadeModalPopup = function () {
  this.init();
};

fadeModalPopup.prototype = {
  init: function () {
    this.setParams();
    this.openModal();
  },
  setParams: function () {
    this.openLink = 'a[data-modal-fade]';
    this.popupOptions = {
      modalClass: 'fade-modal open',
      blockerClass: 'blocker-fade',
      showClose: false
    }
  },
  setModalTitle: function (modal) {
    // откащались от прилипающего хедера в окне
    var date = modal.find('.detail-content-date[data-modal-date]');
    var title = modal.find('.title[data-modal-title]');
    var headerTitle = modal.find('.fade-popup-header-title');
    headerTitle.append(date.clone());
    headerTitle.append(title.clone());

    modal.on('scroll', function () {
      if(headerTitle.parent().offset().top + headerTitle.parent().outerHeight() > title.offset().top + title.outerHeight()) {
        headerTitle.parent().addClass('shown-title');
      } else {
        headerTitle.parent().removeClass('shown-title');
      }
    })
  },
  openModal: function () {
    var self = this;
    var linkTarget;
    var headerHeight;
    var detailItem;

    $(document).on('click', this.openLink, function (e) {
      e.preventDefault();
      linkTarget = $(this).data('modal-fade');
      $('.sub-mobile').css('display', 'none');
      headerHeight = $('.main-nav-container').outerHeight(true) + parseInt($('header').css('top')) + $('header').outerHeight(false) - $('.sub-mobile').outerHeight() + 'px';
      $('#' + linkTarget).css({
        'top': headerHeight,
        'height': 'calc(100vh - ' + headerHeight + ')'
      });
      $('#' + linkTarget).on($.modal.CLOSE, function () {
        detailItem = null;
        $(this).find('.item-detail-content').remove();
        $('.sub-mobile').css('display', 'block');
      });

      if ($(this).attr('data-modal-ajax') !== undefined) {
        $('body').addClass('loading');
        $('#' + linkTarget).children('.fade-popup-content').load($(this).attr('href') + ' #ajax-page-content', function(response, status, xhr) {
          if (status === 'success') {
            $('#' + linkTarget).modal(self.popupOptions);
            detailItem = new detailItemApp();
            changeDefaultClosing();
          } else {
            alert('Ошибка при загрузке!');
          }
        });
        $('#fade-modal-ajax').on('scroll', function (e) {
          $(this).find('#social-share-block').removeClass('active');
        })
      } else {
        $('#' + linkTarget).modal(self.popupOptions);
        changeDefaultClosing();
      }
      $('body').addClass('print-only-ajax');
      return false
    })
  }
};

function changeDefaultClosing(){
  "use strict";
  $('.blocker').unbind('click');
  $('.blocker').on('click',function(e){
    "use strict";
    if(e.target===$(this)[0]){
      e.stopPropagation();
      e.preventDefault();
      $('body').removeClass('print-only-ajax');
      $('.fade-modal').addClass('modal-hide');
      setTimeout(function(){
        "use strict";
        $('.fade-modal').removeClass('modal-hide');
        $.modal.close();
      },500);
    } else {
      return e;
    }
  });
}

new fadeModalPopup();
var MainMenuStyler=function(){
    "use strict";

};

MainMenuStyler.prototype={
    getSupportedPropertyName: function(properties) {
        for (var i = 0; i < properties.length; i++) {
            if (typeof document.body.style[properties[i]] != "undefined") {
                return properties[i];
            }
        }
        return null;
    },
  init: function($selector){
      "use strict";
      var scrollTop=0;
      var direction='down';
      var height=$selector.height();
      var scroll=0;
      var mainPageHead=$('.index-page-head');

      var mainNavHeight=$('.main-nav-container').height();
      if(mainNavHeight>100){
          mainNavHeight=100
      }

      $('.content').css('padding-top',height+mainNavHeight);

      if(mainPageHead.length){
          $('body').addClass('index');
          $('.main-nav-menu').addClass('index-page');
      }
      $('body').bind('mousewheel DOMMouseScroll MozMousePixelScroll', function(event) {
          var delta = parseInt(event.originalEvent.wheelDelta || -event.originalEvent.detail);
          scroll=pageYOffset;
          scrollTop=scroll;
          if(!$(this).hasClass('print-only-ajax')){
              if (delta >= 0) {
                  direction="up";
              } else {
                  direction='down';
              }
          }
      });
      var scrollingBlock=$('.section-menu-fixed')[0];
      var transform = ["transform", "msTransform", "webkitTransform", "mozTransform", "oTransform"];
      var transformProperty = this.getSupportedPropertyName(transform);

      $('.js-close').on('click',function(){
          $(this).parent().parent().fadeOut();
      });

      if($('.section-menu-fixed').length){
          $('.page-content').css('min-height',$('.section-menu-fixed').height()+400);
      }

      var topMarg=$(window).height()-155;
      var wHeight=$(window).height()-155;
      if(wHeight>600){
          wHeight=600;
      }
      if(!detectMob()){
          $(window).resize(function(){
              topMarg=$(window).height()-155;
              wHeight=$(window).height()-155;
              if(topMarg>600){
                  topMarg=600;
              }
              if(wHeight>600){
                  wHeight=600;
              }
              $('.index').css('padding-top',topMarg-25);
          });
      }


      setBannerHeight(mainPageHead);
      function setBannerHeight(mainPageHead){
          var mainPageHeadHeight=wHeight-pageYOffset;
          if(mainPageHead.length){
              if(mainPageHeadHeight<=0){
                  mainPageHeadHeight=0;
                  if($('.main-nav-menu').hasClass('index-page')){
                      $('.main-nav-menu').removeClass('index-page');
                  }
              } else{
                  if(!$('.main-nav-menu').hasClass('index-page')){
                      $('.main-nav-menu').addClass('index-page');
                  }
              }
              mainPageHead.css('height',mainPageHeadHeight);
          }
      }
      function checkMenu(){
          if($('.footer').length){
              var blockHeight=$('.section-menu-fixed').height();
              var ClHeight=-180+$(window).height();

              var sectMenuTop=$('.footer').offset().top - blockHeight-400;
              if(ClHeight<blockHeight){
                  sectMenuTop = ClHeight-300;
              }
              scrollTop=pageYOffset;
              if(scrollingBlock){
                  if(scrollTop>sectMenuTop){
                      if (transformProperty) {
                          var a=sectMenuTop-scrollTop;
                          scrollingBlock.style[transformProperty] = 'translate3d(0, '+a+'px, 0)';
                      }
                  } else {
                      scrollingBlock.style[transformProperty] = 'translate3d(0, 0, 0)';
                  }
              }
          }
            setBannerHeight(mainPageHead);
              if(direction=='down'){
                  $('body').removeClass('main-menu-fixed-show');
                  if(scrollTop>height){
                      if(!$('body').hasClass('main-menu-fixed')){
                          $('body').addClass('main-menu-fixed');
                      }
                  } else {
                      if($('body').hasClass('main-menu-fixed')){
                          $('body').removeClass('main-menu-fixed');
                      }
                  }
              } else {
                  if($('body').hasClass('main-menu-fixed')){
                      $('body').addClass('main-menu-fixed-show');
                  }
                  if(scrollTop<=height) {
                      if($('body').hasClass('main-menu-fixed')){
                          $('body').removeClass('main-menu-fixed-show');
                          $('body').removeClass('main-menu-fixed');
                      }
                  }
              }
              requestFrame(checkMenu);


      }
      checkMenu();

      if(topMarg>600){
          topMarg=600;
      }
      $('.index').css('padding-top',topMarg-25);

  },
  hamburgerMenu:function(){
      "use strict";
      $('.hamburger .hamburger-button').on('click',function(){
         if(!$(this).closest('.hamburger').hasClass('active')){
             $(this).closest('.hamburger').addClass('active');
         } else  {
             $(this).closest('.hamburger').removeClass('active');
         }
      });
      $('.hamburger-mobile .hamburger-button').on('click',function(){
         $('.main-mobile .mobile-active').trigger('click');
      });
  },
    menuFlex:function(){
        "use strict";
        $('.flex-menu').flexMenu();
    },
    mobileActiveSet: function(){
        "use strict";

        var transform = ["transform", "msTransform", "webkitTransform", "mozTransform", "oTransform"];
        var transformProperty = this.getSupportedPropertyName(transform);
        $('.mobile-active').each(function(){
            var $active=$(this).parent().find('ul li a.active');

            $(this).text($active.text());
            if($active.text()==''){
                $(this).text('Главная');
            }
        });
        $('.mobile-active').on('click',function(){
            if(!$(this).parent().hasClass('active')){
                $(this).parent().addClass('active');
                $('body').css({'overflow':'hidden','max-height':'100vh'})
            } else {
                $(this).parent().removeClass('active');
                $('body').attr('style','');
            }
        });
        if(!$('.sub-mobile-menu-slider-item-menu').length){
            $('.sub-mobile-menu').addClass('hide-arrow')
        }
        $('.sub-mobile-menu-slider-item-head').bind('click',function(){
            if($(this).closest('.sub-mobile-menu').find('.sub-mobile-menu-slider-item-menu').length){
                if(!$(this).closest('.sub-mobile-menu').hasClass('active')){
                    $(this).closest('.sub-mobile-menu').addClass('active');
                } else {
                    $(this).closest('.sub-mobile-menu').removeClass('active');
                }
            }
        });
        var elements=[];
        var bg=$('.main-nav-container').attr('style');
        $('.mob-bg').attr('style',bg);
        $('.main-mobile').find('.parent').each(function(){
            var obj={
                top: $(this).offset().top-$(window).scrollTop(),
                el: $(this)
            };
            elements.push(obj);
        });
        $(window).resize(function(){
            elements=[];
            $('.main-mobile').find('.parent').each(function(){
                $(this).attr('style','');
                var obj={
                    top: $(this).offset().top-$(window).scrollTop(),
                    el: $(this)
                };
                elements.push(obj);
            });
        });
        var length=elements.length;
        var scroll=0;
        $('.main-mobile .mob-bg').scroll(function(){
            scroll=$(this).scrollTop();
        });
        function step(){
            $('.parent.fixed').removeClass('scroll');
            for(var i=0;i<length; i++){
                var elem=elements[i];
                var prev=elements[i-1];
                if(prev){
                    if(scroll>elem.top-100) {
                        var scrTop=elem.top-100-scroll;
                        var transformString='translate3d(0, '+scrTop+'px, 0)';
                        prev.el.attr('style','position: fixed; top: 65px; z-index: 10; opacity :0; '+transformProperty+':'+transformString+';');
                    }
                    else {
                        prev.el.attr('style','');
                        elem.el.attr('style','');
                    }
                }
                if(scroll>elem.top-60){
                        if(scroll<elem.top-50) {
                            elem.el.removeClass('scroll').addClass('fixed');
                        }
                    }

                    else {
                        elem.el.removeClass('fixed').addClass('scroll');
                        elem.el.attr('style','');
                    }
            }
            requestFrame(step)
        }
        //step();


    }
};

var mainMenu=new MainMenuStyler();

mainMenu.init($('header.header'));
mainMenu.hamburgerMenu();
mainMenu.menuFlex();
mainMenu.mobileActiveSet();
(function($){
    "use strict";
    if($('.accord-block').length){


        $('.has-tabs').each(function(index){
            var tabs=$(this).find('.articles-block-tabs');
            var controls=$(this).find('.accord-block-tabs');
            var count=controls.find('.accord-block-tabs-item').length;
            tabs.attr('data-tabs',index);
            controls.attr('data-tabs',index);

            tabs.slick({
                arrows: false,
                dots:false,
                asNavFor: controls,
                adaptiveHeight: true
            });

            controls.slick({
                arrows: false,
                dots:false,
                slidesToShow: count,
                asNavFor: tabs,
                focusOnSelect: true
            });

        });

        var $acBlock=$('.accord-block-item.active').find('.accord-block-item-content');
        var innerBlock = $acBlock.find('.accord-block-item-content-inner');
        var blockHeight=innerBlock.height()+50;
        $acBlock.animate({height:blockHeight},500);

        $(window).resize(function(){
            blockHeight=innerBlock.height()+100;
            $acBlock.animate({height:blockHeight},500);
        });

        $('.accord-block-item-title h2').on('click',function(){
           var $acBlock=$(this).closest('.accord-block-item').find('.accord-block-item-content');
           var $parent= $(this).closest('.accord-block-item');
           var innerBlock = $acBlock.find('.accord-block-item-content-inner');
           var blockHeight=innerBlock.height()+50;
            if($parent.hasClass('active')){
                $parent.removeClass('active');
                $acBlock.animate({height:0},800);
            } else {
                $parent.addClass('active');
                $acBlock.animate({height:blockHeight},500);
            }
        });



    }

    $('[data-tab-href]').on('click',function(){
        var url=$(this).attr('data-tab-href');
        $(this).closest('.accord-block-item').find('[data-tab-href-target]').attr('href',url);
    });

    $('.time-tabs [data-time-tab]').on('click',function(){
        var selector='.time-tabs-body [data-time-tab="'+$(this).attr('data-time-tab')+'"]';
        $(this).closest('.vote-sector-block').find('.time-tabs [data-time-tab]').removeClass('active');
        $(this).closest('.vote-sector-block').find('.time-tabs-body [data-time-tab]').removeClass('active');
        $(this).addClass('active');
        $(this).closest('.vote-sector-block').find(selector).addClass('active');
        $(window).trigger('resize');
    });



})($);
var TopMenuPanel=function(){
    "use strict";

};

TopMenuPanel.prototype={
  init:function(){
      "use strict";
      this.createPanel();
      this.initInfoChange();
  },
    createPanel:function(){
        "use strict";
        var topPanel='<div class="top-panel"><div class="title"></div><div class="scroll-up"></div></div>';
        $(topPanel).insertAfter('.sub-menu');
        $('.sub-menu').addClass('top-panel-wraper');

        $('.scroll-up').on('click',function(){
            $('html, body').animate({scrollTop: 0},800);
        })
    },
    initInfoChange:function(){
        "use strict";
        var elements=[];
        $('[data-top-panel]').each(function(){
            var el={
              title:$(this).find('[data-top-panel-title]').text(),
              element:$(this)
            };
            elements.push(el);
        });
        var length=elements.length;
        var $textBlock=$('.top-panel .title');
        var text='';
        function step(){
            var top=pageYOffset;
            for(var i=0;i<length;i++){
                var element=elements[i];
                    var elTop=element.element.offset().top;
                    var elHeight=element.element.height();
                    if(top>=elTop){
                        if(top<=elTop+elHeight){
                            showHidePanel(true);
                            if(element.title!=text){
                                $textBlock.text(element.title);
                                text=element.title;
                            }
                        }
                    }
                if(top<=0){
                    showHidePanel(false);
                }
            }
            requestFrame(step);
        }
        function showHidePanel(show){
            if(show){
                $('.sub-menu').parent().addClass('panel-show');
            } else {
                $('.sub-menu').parent().removeClass('panel-show');
            }
        }
        step();
    }

};

(function($,TopMenuPanel){
    "use strict";
    if($('[data-top-panel]').length){
        window.topMenuPanel=new TopMenuPanel();
        window.topMenuPanel.init();
    }

})($,TopMenuPanel);
(function ($) {
  "use strict";
  var $shareBlock = $('#social-share-block');
  $(document).on('click', '.icon-link.share', function (e) {
    if ($(this).closest('#ajax-page-content').find('#social-share-block').length) {
        $shareBlock = $(this).closest('#ajax-page-content').find('#social-share-block')
    }
    e.preventDefault();
    var offset = $(this).offset();
    var top = offset.top + 25 - pageYOffset;
    var left = offset.left + $(this).width() + 80;
    $shareBlock.css({'top': top, 'left': left});
    $shareBlock.addClass('active');
  });

  $('body').on('click scroll', function (e) {
    if (e.target != $('.icon-link.share')[0]) {
      $shareBlock.attr('style', '');
      $shareBlock.removeClass('active');
    }
  });

  //$('.icon-link.print').on('click', function () {
  //  window.print();
  //});

  $(window).on('scroll', function (e) {
    $('#social-share-block').removeClass('active');
  })

})($);
var DropeZoneForm=function(){};

DropeZoneForm.prototype={
  init: function(){
      "use strict";
      var self=this;
      self.files=[];

      if($('[data-dz-message]').length){
          self.dropZone = $('[data-dz-message]');
          self.dropZoneText=self.dropZone.html();
          self.maxFileSize = 5000000;
          self.maxFileCount=5;
          if (typeof(window.FileReader) == 'undefined') {
              self.dropZone.text('Не поддерживается браузером!');
              self.dropZone.addClass('error');
          }
          self.dropZone[0].ondragover = function() {
              self.dropZone.addClass('hover');
              return false;
          };
          self.dropZone[0].ondragleave = function() {
              self.dropZone.removeClass('hover');
              return false;
          };
          var input = $('input#files[type="file"]');
          input.on('change',function(){
              "use strict";
              var input=$(this)[0];
              var f=input.files;
              var length=f.length;
              for(var i=0;i< length ;i++){
                  if (f[i].size > self.maxFileSize) {
                      self.dropZone.text('Файл слишком большой!');
                      self.dropZone.addClass('error');
                      setTimeout(function(){
                          self.refreshDropezoneMessage();
                      },2000);
                      return false;
                  }
                  if(self.maxFileCount<=self.files.length){
                      self.viewFiles(self.files);
                      self.dropZone.addClass('error');
                      return false;
                  }
                  if(!self.checkValidExtension(self.validExt,f)){
                      self.dropZone.text('Разрешенные расширения файлов '+self.validExt+'!');
                      self.dropZone.addClass('error');
                      setTimeout(function(){
                          self.refreshDropezoneMessage();
                      },2000);
                      return false;
                  }
                  self.files.push(f[i]);
              }
              self.viewFiles(self.files);
          });
          self.dropZone[0].ondrop = function(event) {
              event.preventDefault();
              self.dropZone.removeClass('hover');
              self.dropZone.addClass('drop');
              var file = event.dataTransfer.files;
              var lenght=file.length;

              for(var i=0;i<lenght;i++){
                  if (file[i].size > self.maxFileSize) {
                      self.dropZone.text('Файл слишком большой!');
                      self.dropZone.addClass('error');
                      setTimeout(function(){
                          self.refreshDropezoneMessage();
                      },2000);
                      return false;
                  }
                  if(self.maxFileCount<=self.files.length){
                      self.dropZone.addClass('error');
                      self.viewFiles(self.files);
                      return false;
                  }
                  if(!self.checkValidExtension(self.validExt,file)){
                      self.dropZone.text('Разрешенные расширения файлов '+self.validExt+'!');
                      self.dropZone.addClass('error');
                      setTimeout(function(){
                          self.refreshDropezoneMessage();
                      },2000);
                      return false;
                  }
                  self.files.push(file[i]);
              }
              self.viewFiles(self.files);
          };

      }
  },
    viewFiles: function(file){
            "use strict";
        var self=this;
            var lenght=file.length;
            var $prev=$('#template-preview');
            var filePrev='';
            for(var i=0;i<lenght;i++){
                filePrev=filePrev+'<div class="file"><div class="inner">'+file[i].name+'<a href="#" class="js-delete-file" data-filename="'+file[i].name+'">del</a></div></div>';
            }
            $prev.html(filePrev);
            $('[data-files-count]').text('Прикреплено '+lenght);
            if(lenght==0){
                $('[data-files-count]').text('');
            } else if(self.maxFileCount<=self.files.length){
                self.dropZone.text('Можно прикрепить только '+self.maxFileCount+' файлов');
                setTimeout(function(){
                    self.refreshDropezoneMessage();
                },2000);
            }

            $('.js-delete-file').unbind('click');
            $('.js-delete-file').bind('click',function(e){
                e.preventDefault();
                var name=$(this).attr('data-filename');
                self.deleteFile(name);
            });

},
    deleteFile :function (fileName){
            "use strict";
        var self=this;
            var index;
            var lenght=self.files.length;
            for(var i=0; i<lenght; i++){
                var fName=String (self.files[i].name);
                if (fName == fileName) {
                    index=i;
                }
            }

            if(index>=0){
                self.files.splice(index,1);
            }
        self.viewFiles(self.files);
},
    sendForm :function(form){
        var self=this;
        "use strict";
        var url=form.attr('action');
        var data = new FormData(form[0]);
        $.each( self.files, function( key, value ){
            var name='file['+key+']';
            data.append( name, value );
        });
        $.ajax({
            url: url,
            type: 'POST',
            data: data,
            cache: false,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function( respond, textStatus, jqXHR ){
                if(respond.stat == 'ok'){
                    $('.success[data-form-result]').fadeIn();
                } else {
                    $('.error[data-form-result]').fadeIn();
                }
            },
            error: function( jqXHR, textStatus, errorThrown ){
                $('.error[data-form-result]').fadeIn();
            }
        });
    },
    options:function(options){
        "use strict";
        this.maxFileSize=options.maxFileSize*1000000;
        this.maxFileCount=options.maxFileCount;
        this.validExt=options.validExt
    },
    checkValidExtension:function(ext,f){
        "use strict";
        var self=this;
        var lenght=f.length;
        var valid=false;

        for(var i=0; i<lenght; i++){
            valid=false;
            var fName=String (f[i].name);
            var extension = fName.substr(fName.lastIndexOf('.'));
            for(var j=0;j<ext.length;j++){

                if(ext[j]==extension.toLowerCase()){
                    valid=true;
                }
            }
        }
        return valid;
    },
    refreshDropezoneMessage:function(){
        "use strict";
        var self=this;
        self.dropZone.html(self.dropZoneText);
        self.dropZone.removeClass('error');
    }
};







var dropeform=new DropeZoneForm();

dropeform.init();

dropeform.options({
    maxFileSize: 5,
    maxFileCount: 1,
    validExt: ['.jpg', '.gif', '.bmp', '.png', '.jpeg', '.doc', '.txt', '.rtf', '.pdf', '.xls', '.docx', '.xlsx', '.odt', '.odf']
});

//$('.dropzone').on('click',function(e){
//    "use strict";
//   if((e.target==$('.dropdown-group .dropdown-control')[0])||(e.target==$('.dropdown-group .group-text-input')[0])){
//       return;
//   }
//    $('.dropdown-group').removeClass('open');
//});


$('input.js-client-phone').inputmask({
    // mask: '+7 (999) 999-99-99',
    regex: '^\\+7\\([3|4|8|8|9]{1}[0-9]{2}\\)[0-9]{3}-[0-9]{2}-[0-9]{2}$',
    placeholder: '+7(___)___-__-__',
    showMaskOnHover: false,
    greedy: false,
});


$('form.ajax-form').on('submit',function(e){
    "use strict";
    e.preventDefault();
    if(!validateForm($(this))){
        return false;
    }
    window.dropeform.sendForm($(this));
});


$('[data-close-message]').on('click',function(e){
    "use strict";
    e.preventDefault();
    $(this).closest('.form-result').fadeOut();
    if($(this).closest('.form-result').hasClass('success')){
        $('.blocker-fade.blocker.current').trigger('click');
    }
});

function validateForm($form){
    "use strict";
    var valid=true;
    $form.find('[data-required]').each(function(){
       if(!$(this).val()){
           valid=false;
           $(this).parent().addClass('error');
       }
        else {
           $(this).parent().removeClass('error');
       }
    });
    if(valid==true){
        if(!$('[data-privacy]').prop("checked")){
            valid=false;
            $('[data-privacy]').parent().addClass('error');
        } else {
            $('[data-privacy]').parent().removeClass('error');
        }
    }

    console.log(valid);

    return valid;
}
(function ($) {

    var value;

    $('[data-max-symbols-count]').each(function () {
        indicate($(this));
    });
    
    $('[data-max-symbols-count]').on('keydown',function(e){
        var check=indicate($(this));
        if(check.l>check.maxCount){
            if(e.keyCode!=8)
                return false;
        }
    });

  function indicate($input) {
      var maxCount=parseInt($input.attr('data-max-symbols-count'));
      var selector='[data-input="'+$input.attr('id')+'"]';
      var $indicator=$(selector);
      var currentValue=$input.val();
      var l=currentValue.length;
      value=currentValue;
      $indicator.text(l+' / '+maxCount);
      return {
          l:l,
          maxCount:maxCount
      }
  }
    
})($);
(function ($) {


    var MouseCoords = {

        // X-координата
        getX: function(e)
        {

            if (e.clientX)
            {
                return e.clientX+(document.documentElement.scrollLeft || document.body.scrollLeft) - document.documentElement.clientLeft;
            }

            return 0;
        },

        // Y-координата
        getY: function(e)
        {
            if (e.pageY)
            {
                return e.pageY;
            }
            else if (e.clientY)
            {
                return e.clientY+(document.documentElement.scrollTop || document.body.scrollTop) - document.documentElement.clientTop;
            }

            return 0;
        }
    };

    var x,y;

    document.onmousemove = function(e)
    {
        if (!e) e = window.event;
        x=MouseCoords.getX(e);
        y=MouseCoords.getY(e);

    };

    $('[data-modal-text]').on('mousemove touchend',function (e) {
        var selector=$(this).attr('data-modal-text');
        var $modal=$('#'+selector);
        var top=y-$modal.height()-70-pageYOffset;
        if(!$modal.hasClass('active')){
            $modal.addClass('active');
        }
        var left=x-$modal.width()/2;
        if((top)<120){
            console.log('more');
            top=y+15-pageYOffset;
        }
        $modal.css({'top':top,'left':left});
    });
    $('body').on('click',function (e) {
        if(e.target!=$('.modal-text-content')[0]){
            $('.modal-text-content').removeClass('active').attr('style','');
        }
    });
    $('[data-modal-text]').on('mouseleave',function (e) {
        window.modalTextTimer=setTimeout(function(){
            "use strict";
                $('.modal-text-content').removeClass('active').attr('style','');
        },200);
    });

    $('.modal-text-content').on('mouseleave',function (e) {
        $('.modal-text-content').removeClass('active').attr('style','');
    });

    $('.modal-text-content').on('mouseenter',function () {
        "use strict";
        clearTimeout(window.modalTextTimer);
    });

    $('.modal-text-content').bind('mousewheel DOMMouseScroll', function(e) {
        var scrollTo = null;
        if (e.type == 'mousewheel') {
            scrollTo = (e.originalEvent.wheelDelta * -1);
        }
        else if (e.type == 'DOMMouseScroll') {
            scrollTo = 40 * e.originalEvent.detail;
        }
        if (scrollTo) {
            e.preventDefault();
            $(this).scrollTop(scrollTo + $(this).scrollTop());
        }
    });


})($);
var AjaxBlockLoader=function(){
    "use strict";
    this.parentBlock=null;
    this.activeLink=null;

};

AjaxBlockLoader.prototype={
    init: function(){
        "use strict";
        var self=this;
        $('.ajax-load-menu a').on('click',function(e){
            e.preventDefault();
           var url=$(this).attr('href');
            self.parentBlock=$(this).closest('.ajax-load-section');
            self.activeLink=$(this);
            self.getData(url);
        });
        this.initSlider();

    },
    updateBlock: function(html){
        "use strict";
        var self=this;
            self.parentBlock.removeClass('loading');
        if(html){
            self.parentBlock.find('.ajax-load-block').html(html);
            self.parentBlock.find('.ajax-load-menu a').removeClass('active');
            self.activeLink.addClass('active');
            //$('html, body').animate({scrollTop:  self.parentBlock.offset().top-100},200);
        }
        else{
            self.parentBlock.removeClass('loading').addClass('error');
            setTimeout(function(){
                self.parentBlock.removeClass('error');
            },2000)
        }

    },
    getData:function(url,callBack){
        "use strict";
        var self=this;
        self.parentBlock.addClass('loading');
        $.ajax({
            url: url,
            success: function(data){
                self.updateBlock(data);
                self.initAfterRefresh();
                if(callBack){
                    callBack();
                }

            },
            error:  function(data){
                self.updateBlock();
            }
        });
    },
    initSlider: function(){
        "use strict";
        var $slider=$('[data-events-slider]');
        if($slider.length){
            $slider.slick({
                dots: true,
                arrows: false,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                adaptiveHeight: true
            });
        }
    },
    initAfterRefresh:function(){
        var self=this;
        if(self.parentBlock.find('.ajax-load-block').find('[data-events-slider]').length){
            if(!detectMob()){
                self.initSlider();
            }
        }
        if(self.parentBlock.find('.index-city-num').length){
            $('.index-city-num .section-list-wrap').slick({
                responsive: [
                    {
                        breakpoint: 9999,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            dots: false,
                            arrows: false,
                            infinite: false,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
        if(window.eventsCalendar){
            if($('#events-calendar').length){
                window.eventsCalendar.buildCalendar();
            }
        }
    }
};

if($('.ajax-load-section').length){
    window.ajaxLoadSeciton=new AjaxBlockLoader();
    ajaxLoadSeciton.init();
}

var UsefullLinksRotator = function(){
  "use strict";
};

UsefullLinksRotator.prototype={
  initRotator: function($container,$item){
    "use strict";
    var self=this;
    self.containers=[];
    self.item=$item;
    self.block=$container;
    self.correction=$container.find($item).outerHeight(true)-$container.find($item).outerHeight();
    console.log(self.correction);
    $container.each(function(){
      var elem={
        container:$(this),
        maxCount:$(this).attr('data-js-rotator'),
        blockMaxHeight:$(this).attr('data-js-rotator')*$(this).find($item).outerHeight(true)
      };
      self.containers.push(elem);
    });
    self.build();
  },
  build: function(){
    "use strict";
    var self=this;
    var length=self.containers.length;
    for(var i=0;i<length;i++){
      var block=self.containers[i];
      var count=block.container.find(self.item).length;
      var blockMaxHeight=block.blockMaxHeight;
      if(count>block.maxCount){
        var html=block.container.html();
          block.container.html('<div class="overflow"><div class="overflow-content">'+html+'</div></div>');
          block.container.find('.overflow').css('height',blockMaxHeight);
          block.transform=0;
          block.beforeCount=0;
          block.afterCount=count-block.maxCount;
          addBlockButton(count-block.maxCount,block.container,i);

        refreshButtons(0,count-block.maxCount,block.container);
      }
    }


    for(var j=0;j<length;j++){
      var bl= self.containers[j];
      var upButton=bl.container.find('.rotator-button').filter(':first');
      var downButton=bl.container.find('.rotator-button').filter(':last');

      upButton.on('click',function(){
        var index=parseInt($(this).attr('data-block-index'));
        scrollBlock('up',self.containers[index]);
      });
      downButton.on('click',function(){
        var index=parseInt($(this).attr('data-block-index'));
        scrollBlock('down',self.containers[index]);
      });
    }



    function scrollBlock(direction,block){
        if(direction=='down'){
          if(block.afterCount>0){
            if(block.transform<=0){
              block.transform=block.transform-block.blockMaxHeight+self.correction;
              block.beforeCount=block.beforeCount+parseInt(block.maxCount);
              block.afterCount=block.afterCount-parseInt(block.maxCount);
              block.container.find('.overflow-content').css('transform','translate3d(0,'+block.transform+'px,0)')
            }
          }
        } else {
          if(block.beforeCount>0){
            if(block.transform<=0){
              block.transform=block.transform+block.blockMaxHeight-self.correction;
              block.beforeCount=block.beforeCount-parseInt(block.maxCount);
              block.afterCount=block.afterCount+parseInt(block.maxCount);
              block.container.find('.overflow-content').css('transform','translate3d(0,'+block.transform+'px,0)')
            }
          }
        }
      refreshButtons(block.beforeCount,block.afterCount,block.container);
    }
    function addBlockButton(count,parent,id){
      "use strict";
      var text=parent.attr('data-text');
      text=text.replace('num',count);
      var blockButton='<div class="rotator-button active" data-block-index="'+id+'">'+text+'</div>';
      if(!parent.find('.rotator-button').length){
          parent.append(blockButton);
          $(blockButton).insertBefore(parent.find('.overflow'));
      }
    }
    function refreshButtons(frstCount,lstCount,parent){
      var upButton=parent.find('.rotator-button').filter(':first');
      var downButton=parent.find('.rotator-button').filter(':last');
      var text;
      var itemsCount=parent.find(self.items).length;
      if(frstCount>0){
        text=parent.attr('data-text');
        text=text.replace('num',frstCount);
        upButton.text(text);
      } else {
        upButton.removeClass('active');
        downButton.addClass('active');
      }
      if(lstCount>0){
        text=parent.attr('data-text');
        text=text.replace('num',lstCount);
        downButton.text(text);
      } else {
        downButton.removeClass('active');
        upButton.addClass('active');
      }
    }
  },

  setEvents: function(){
    "use strict";
    var self=this;

  }

};


var linksRotatorBlocks=new UsefullLinksRotator();

linksRotatorBlocks.initRotator($('[data-js-rotator]'),'[data-js-rotator-item]');


$('[data-mobile-modal-menu] [data-mobile-modal]').on('click',function(){
  "use strict";
  $('[data-mobile-modal]').removeClass('active');
  var selector=$('[data-mobile-modal="'+$(this).attr('data-mobile-modal')+'"]');
  selector.addClass('active');
});

$('.js-close-mobile-modal').on('click',function(){
  "use strict";
  $(this).closest('.rotatotion-block').removeClass('active');
});

var EventsCalendar= function(){
    "use strict";

};

EventsCalendar.prototype={
    init:function(sel){
        "use strict";
        var self=this;
        self.sel=sel;
        if(self.date){
            self.date=new Date();
        }
        self.calendarReady=true;
        var $selector=$(self.sel);
        var range=$selector.parent().find('[data-calendar-range]');
        if(range.length){
            self.start=range.attr('data-min');
            self.start=self.start.split('.');
            self.end=range.attr('data-max');
            self.end=self.end.split('.');
            self.buildCalendar();
        }
    },
    buildCalendar:function () {
        var self=this;
        if (!self.sel){
            self.sel=('#events-calendar')
        }
        var $selector=$(self.sel);
        var start=self.start;
        var end=self.end;
        var range=$selector.parent().find('[data-calendar-range]');
        if(!start){
            start=range.attr('data-min');
            start=start.split('.');
        }
        if(!end){
            end=range.attr('data-max');
            end=end.split('.');
        }
        var options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            timezone: 'UTC'
        };
        var mxDate=new Date(parseInt(end[2]),parseInt(end[1])-1,parseInt(end[0]));
        var mnDate=new Date(parseInt(start[2]),parseInt(start[1])-1,parseInt(start[0]));
        var ev=$('[data-event-calendar-items]').find('[data-event-calendar-date]');
        var eventDates = [];
        ev.each(function () {
           var date=$(this).attr('data-event-calendar-date') ;
            date=date.split('.');
            eventDates.push(parseInt(date[0]));
        });
        if($selector.length){
            self.calendar=$selector.datepicker({
                minDate: mnDate,
                maxDate: mxDate,
                showOtherMonths: false,
                selectOtherMonths: false,
                startDate:self.date,
                onChangeMonth: function(m,y){
                    window.ajaxLoadSeciton.parentBlock=$('#events-calendar').closest('.ajax-load-section');
                    window.ajaxLoadSeciton.activeLink=$('.ajax-load-menu .active');
                    var $form=$('form.events-calendar-filter');
                    var date=new Date(y,m);
                    var dateFrom=new Date(y,m);
                    dateFrom.setDate(dateFrom.getMonth()-1);
                    $form.find('[data-filter-from]').val(dateFrom.toLocaleString("ru", options));
                    $form.find('[data-filter-to]').val(date.toLocaleString("ru", options));
                    self.date=date;
                    var data=$form.serialize();
                    var url=$form.attr('action');
                    window.ajaxLoadSeciton.getData(url+'?'+data,function () {
                        self.buildCalendar();
                    });
                },
                onChangeYear: function(y){

                },
                onRenderCell: function (date, cellType) {
                    var currentDate = date.getDate();
                    if (cellType == 'day' && eventDates.indexOf(currentDate) != -1) {
                        return {
                            html: currentDate + '<span class="dp-note"></span>'
                        }
                    }
                },
                onSelect: function onSelect(fd, date) {
                    if (date && eventDates.indexOf(date.getDate()) != -1) {
                       var selector='[data-event-calendar-date="'+date.toLocaleString("ru", options)+'"]';
                        $('[data-event-calendar-date]').removeClass('active');
                        $(selector).addClass('active');
                    }
                }
            }).data('datepicker');
        }
    }
};

var eventsCalendar=new EventsCalendar();

if($('#events-calendar').length){
    eventsCalendar.init('#events-calendar');
}
$(document).ready(function () {
  var $picker = $('#events-calendar-filter');
  var $requestForm = $picker.closest('form');
  var currentDate;
  var currentYear;
  var currentMonth;

  $picker.datepicker({
    onRenderCell: function (date, cellType) {
      currentDate = date.getDate();
      currentYear = date.getFullYear();
      currentMonth = date.getMonth();
      if (cellType == 'day' && eventDates[currentYear] && eventDates[currentYear][currentMonth] && eventDates[currentYear][currentMonth].indexOf(currentDate) != -1) {
        return {
          html: currentDate + '<span class="dp-note"></span>'
        }
      } else {
        if (cellType == 'day') {
          return {
            disabled: true
          }
        }
      }
    },
    onSelect: function onSelect(fd, date) {
      date = new Date(date);
      var toDate=new Date(date);
      toDate.setHours(23,59,59);
      var options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        timezone: 'UTC'
      };
      $requestForm.find('[data-date-from]').val(date.toLocaleString("ru", options) +' '+date.toLocaleTimeString('en-US', { hour12: false }));
      $requestForm.find('[data-date-to]').val(toDate.toLocaleString("ru", options) +' '+toDate.toLocaleTimeString('en-US', { hour12: false }));
      $('body').addClass('loading');
      $.get({
        url: $requestForm.attr('action'),
        data: $requestForm.serialize(),
        success: function (data) {
          $('#ajax-filter-articles').html($('#ajax-filter-articles-wrap', data));
          $('body').removeClass('loading');
        }
      });
    }
  });
});
/**
 * Created by Санчес on 28.12.2017.
 */

$('[data-tabs-container]').each(function(index){
    var tabs=$(this).find('[data-tabs-content]');
    var controls=$(this).find('[data-tabs-menu]');
    var count=controls.find('[data-tabs-menu-item]').length;
    tabs.attr('data-tabs',index);
    controls.attr('data-tabs',index);

    controls.find('a').on('click',function(event){
        "use strict";
         event.preventDefault();
    });

    tabs.slick({
        arrows: false,
        dots:false,
        asNavFor: controls,
        adaptiveHeight: true,
        draggable:false
    });

    controls.slick({
        arrows: false,
        dots:false,
        slidesToShow: count,
        asNavFor: tabs,
        focusOnSelect: true,
        draggable:false
    });

});
var SpecialVersion=function(){};


SpecialVersion.prototype={
  init:function($beforeBlock,spesialClass,whiteClass,blackClass){
      "use strict";
      var self=this;
      self.class=spesialClass;
      self.white=whiteClass;
      self.black=blackClass;
      var template='<div class="special-version"><div class="container"><div class="row"><div class="col-sm-3">';
      template+='<div class="special-version-ui-block"><div class="row"><div class="col-md-6 special-version-ui-block-title">';
      template+='Размер шрифта</div><div class="col-md-6 special-version-ui-block-buttons">';
      template+='<button class="special-version-ui-block-button" data-font-size="14px">A</button><button class="special-version-ui-block-button" data-font-size="16px">A</button>';
      template+='<button class="special-version-ui-block-button" data-font-size="18px">A</button> </div> </div> </div>';
      template+='</div> <div class="col-sm-2"> <div class="special-version-ui-block"><div class="row">';
      template+='<div class="col-md-6 special-version-ui-block-title">Цвет сайта </div> <div class="col-md-6 special-version-ui-block-buttons">';
      template+='<button class="special-version-ui-block-button" data-color-scheme="white">A</button> <button class="special-version-ui-block-button" data-color-scheme="black">A</button>';
      template+='</div> </div> </div> </div> <div class="col-sm-4"> <div class="special-version-ui-block">';
      template+='<div class="row"> <div class="col-md-6 special-version-ui-block-title">Выберите шрифт </div>';
      template+='<div class="col-md-6 special-version-ui-block-buttons"> <button class="special-version-ui-block-button" data-font-family="Arial">Arial</button> <button class="special-version-ui-block-button" data-font-family="Times New Roman">Times New Roman</button>';
      template+='</div> </div> </div> </div> <div class="col-sm-3"> <a href="#" class="special-version-close special-version-ui-block-title" data-special-version-close >Основная версия сайта</a>';
      template+='</div> <div id="special-styles"> <div data-size> </div> <div data-family> </div> </div> </div></div> </div>';
      $(template).insertBefore($beforeBlock);
      self.styleBlock=$('#special-styles');
      self.options=self.getSettings();
      self.options.active=true;
      $('body').addClass(self.class);
      self.setScheme(self.options.scheme);
      self.setFontSize(self.options.fontSize);
      self.setFontFamily(self.options.fontFamily);
      self.setEvents();

  },
  setScheme:function(scheme){
      "use strict";
      var self=this;
      var $page=$('body');
      $page.removeClass(self.white);
      $page.removeClass(self.black);
      if(scheme=='white'){
          $page.addClass(self.white)
      }else{
          $page.addClass(self.black)
      }
      $('[data-color-scheme]').removeClass('active');
      $('[data-color-scheme="'+scheme+'"]').addClass('active');
      self.options.scheme=scheme;
      self.setSettings(self.options);
  },
    setFontSize:function(baseSize){
        "use strict";
        var self=this;
        var style='<style>html {font-size: '+baseSize+';}</style>';
        var stBlock=self.styleBlock.find('[data-size]');
        stBlock.html(style);
        self.options.fontSize=baseSize;
        self.setSettings(self.options);
        $('[data-font-size]').removeClass('active');
        $('[data-font-size="'+baseSize+'"]').addClass('active');
    },
    setFontFamily: function(family){
        "use strict";
        var self=this;
        var font='';
        if(family=='Arial'){
            font='"Arial", sans-serif'
        } else {
            font='"Times New Roman", sans-serif'
        }
        var style='<style>body * {font-family: '+font+'!important;}</style>';
        var stBlock=self.styleBlock.find('[data-family]');
        stBlock.html(style);
        self.options.fontFamily=family;
        self.setSettings(self.options);
        $('[data-font-family]').removeClass('active');
        $('[data-font-family="'+family+'"]').addClass('active');
    },
    setEvents:function(){
        "use strict";
        var self=this;

        $('[data-font-size]').on('click',function(){
            var size=$(this).attr('data-font-size');
            self.setFontSize(size);
        });

        $('[data-font-family]').on('click',function(){
            var family=$(this).attr('data-font-family');
            self.setFontFamily(family);
        });

        $('[data-color-scheme]').on('click',function(){
            var scheme=$(this).attr('data-color-scheme');
            self.setScheme(scheme);
        });

        $('[data-special-version-close]').on('click',function(){
            self.destroi();
        });

    },
    destroi: function(){
        "use strict";
        var self=this;
        var page=$('body');
        $('.special-version').remove();
        self.options.active=false;
        page.removeClass(self.class);
        page.removeClass(self.white);
        page.removeClass(self.black);
        self.setSettings(self.options);
    },
    setSettings: function(options){
        "use strict";
        var self=this;
        if(self.checkStorage()){
            localStorage.setItem("specialVersionOptions1", JSON.stringify(options));
        }
    },
    getSettings: function(){
        "use strict";
        var self=this;
        var options={
            active:false,
            fontSize:'14px',
            scheme:'white',
            fontFamily: 'Arial'
        };
        if(self.checkStorage()){
          var settings=localStorage.getItem("specialVersionOptions1");
            if(settings){
                options=JSON.parse(settings);
            }
        }
        return options;
    },
    checkStorage:function() {
    try {
        return 'localStorage' in window && window['localStorage'] !== null;
    } catch (e) {
        return false;
    }
    },
    checkSpecial:function($beforeBlock,spesialClass,whiteClass,blackClass){
        "use strict";
        var self=this;
        var settings=self.getSettings();
        if(settings.active){
            self.init($beforeBlock,spesialClass,whiteClass,blackClass);
        }
    }
};

window.specialVersion=new SpecialVersion();
window.specialVersion.checkSpecial($('.header'),'special-v','white','black');


$('.top-menu .special').on('click',function(e){
    "use strict";
    e.preventDefault();
    if(!$('.special-v').length){
        specialVersion.init($('.header'),'special-v','white','black');
    } else {
        specialVersion.destroi();
    }
});

(function ($){
    "use strict";
    $('.js-flip-items .section-circle-item').on('click',function(){
        console.log('click');
        if(!$(this).hasClass('flip')){
            $(this).addClass('flip');
        } else {
            $(this).removeClass('flip');
        }
    })
})($);

var SightMap = function(){
    "use strict";
    this.init();
};



SightMap.prototype={

    init:function(){
        "use strict";
        this.initMap();
    },
    initMap:function(){
        "use strict";
        var self=this;
        self.mapContainer=$('#sights-map');
      if(self.mapContainer.length){
          self.mapContainer.addClass('loading');
          this.getApi()
              .then(function(){
                  self.createMap();
              })
              .catch(function(data){
                  $('#sights-map').addClass('error');
              });
      }
    },
    getApi:function(){
        "use strict";
        var self=this;
        if(!window.ymaps){
            return new Promise(function(resolve, reject){
                var yApi=document.createElement('script');
                yApi.type='text/javascript';
                document.body.appendChild(yApi);
                yApi.src='https://api-maps.yandex.ru/2.1/?lang=ru_RU';
                yApi.addEventListener('load',function(){
                    "use strict";
                    resolve();
                },false);
            });
        } else {
            self.createMap();
            return true;
        }
    },
    createMap:function(){
        "use strict";
        var self=this;
        ymaps.ready(function () {
            self.mapZoom=10;
            var lat =43.730502;
            var lng =39.729450;
            self.sightMap = new ymaps.Map('sights-map', {
                    center: [lat, lng],
                    zoom: self.mapZoom,
                    controls: []
                },
                {
                    maxZoom:20,
                    minZoom: 8
                });
            self.sightMap.behaviors.disable('scrollZoom');
            if(detectMob()){
                self.sightMap.behaviors.disable('drag');
            }




            self.initMapControl();
            buildPoligon(self.sightMap,allPoligon);
            //buildPoligon(self.sightMap,krasNkrai);
            buildPoligon(self.sightMap,lazar);
            buildPoligon(self.sightMap,centrR);
            buildPoligon(self.sightMap,hostR);
            buildPoligon(self.sightMap,adlerR);



            addMarks(self.sightMap,self.getMarks(
                $('[data-sights-map-coords]'),
                '[data-sights-map-title]'),
                {
                    iconLayout: 'default#image',
                    iconImageHref: 'img/markerSmap.png', // картинка иконки
                    iconImageSize: [25, 24], // размеры картинки
                    iconImageOffset: [-12, -11] // смещение картинки

                },true);



            var myIconGreen = ymaps.templateLayoutFactory.createClass('<div class="sMapIcon green"><span>' +
                '{{ properties.iconCaption }}' +
                '</span></div>');

            addMarks(self.sightMap,
                [{
                    name: 'Лазаревское',
                    coords: [43.912638, 39.330037]
                }]
                ,
                {
                    iconLayout: myIconGreen

                },false);


            var myIconRed = ymaps.templateLayoutFactory.createClass('<div class="sMapIcon red"><span>' +
                '{{ properties.iconCaption }}' +
                '</span></div>');

            addMarks(self.sightMap,
                [{
                    name: 'Сочи-центр',
                    coords:  [43.586826, 39.718843]
                }]
                ,
                {
                    iconLayout: myIconRed

                },false);


            var myIconYellow = ymaps.templateLayoutFactory.createClass('<div class="sMapIcon yellow"><span>' +
                '{{ properties.iconCaption }}' +
                '</span></div>');

            addMarks(self.sightMap,
                [{
                    name: 'Адлер',
                    coords:  [43.444853, 39.903474]
                }]
                ,
                {
                    iconLayout: myIconYellow

                },false);

            var list=$('#sight-map-list').find('.dropdown-input-list');


            list.find('li').on('click',function(){
                var selector='.sights-map-list [data-sights-map-coords="'+$(this).attr('data-value')+'"]';
                console.log($(selector)[0]);
                $(selector).trigger('click');
            });

            setTimeout(function(){
                self.mapContainer.removeClass('loading');
            },500);

        });




        function addMarks(map,marks,markImgOptions,addEvent){
            var list=$('#sight-map-list').find('.dropdown-input-list');
            for(var i=0;i<marks.length; i++){
                var obj=marks[i];
                var newMark = new ymaps.Placemark(obj.coords,{
                    hintContent: obj.name,
                    balloonContent: obj.name,
                    iconCaption: obj.name
                },
                    markImgOptions
                );
                if(addEvent){

                    newMark.events.add('click', function (e) {
                        var target=e.get('target');
                        var coords=target.geometry._coordinates;
                        coords=coords.toString();
                        var selector='[data-sights-map-coords="'+coords+'"]';

                        $(selector).trigger('click');
                    });

                    var temp='<li data-value="'+obj.coords+'">'+obj.name.replace(/\s{2,}/g, ' ')+'</li>';

                    list.append(temp);

                }
                map.geoObjects.add(newMark);

            }





        }

        function buildPoligon(map,obj){

            var points=obj.points;
            var poligonColor=obj.color;
            var hint=obj.name;

            for(var i=0;i<points.length; i++){
                points[i]=points[i].reverse();
            }

            var myPolygon = new ymaps.Polygon([
                    points
            ], {
                hintContent: hint
            }, {
                fillColor: poligonColor,
                strokeColor: '#ffffff',
                strokeWidth: 5
            });
            map.geoObjects.add(myPolygon);

        }
    },
    initMapControl:function(){
        "use strict";
        var self=this;
        var zoomController=$('[data-zoom-controll]');
        var zoomControllerChanger=zoomController.find('span');
        setLeftPos(self.mapZoom);
        zoomController.on('click',function(e){
            if(e.target==$(this)[0]){
                var offset = $(this).offset();
                var relativeX = (e.pageX - offset.left);
                self.mapZoom=getZoom(relativeX);
                checkRange();
                setLeftPos(self.mapZoom);
                self.sightMap.setZoom(self.mapZoom, {duration: 200});
            }
        });

        self.sightMap.events.add('boundschange', function (e) {
            var newZoom = e.get('newZoom');
            var oldZoom = e.get('oldZoom');
            if (newZoom != oldZoom) {
                self.mapZoom=newZoom;
                setLeftPos(self.mapZoom);
            }
        });

        zoomControllerChanger.on('mousedown',function(e){
            $(this).addClass('move');
        });
        zoomControllerChanger.on('mouseup',function(e){
            $(this).removeClass('move');
            self.mapZoom=getZoom(left);
            checkRange();
            setLeftPos(self.mapZoom);

            self.sightMap.setZoom(self.mapZoom);
        });
        zoomController.on('mousemove',function(e){
            if(zoomControllerChanger.hasClass('move')){
                var offset = $(this).offset();
                var relativeX = (e.pageX - offset.left);
                setLeftPos(getZoom(relativeX));
            }
        });
        zoomController.on('mouseleave',function(){
            zoomControllerChanger.removeClass('move');
        });
        zoomController.find('[data-minus]').on('click',function(e){
            e.preventDefault();
            self.mapZoom--;
            checkRange();
            setLeftPos(self.mapZoom);
            self.sightMap.setZoom(self.mapZoom);
        });

        zoomController.find('[data-plus]').on('click',function(e){
            e.preventDefault();
            self.mapZoom++;
            checkRange();
            setLeftPos(self.mapZoom);
            self.sightMap.setZoom(self.mapZoom);
        });

        zoomController.find('[data-drag]').on('click',function(e){
            e.preventDefault();
            if($(this).hasClass('unlock')){
                self.sightMap.behaviors.disable('drag');
                self.sightMap.behaviors.disable('scrollZoom');
                $(this).removeClass('unlock');
                $(this).html('<i>Разблокировать карту</i>');
            } else {
                self.sightMap.behaviors.enable('drag');
                self.sightMap.behaviors.enable('scrollZoom');
                $(this).addClass('unlock');
                $(this).html('<i>Заблокировать карту</i>');
            }

        });

        function setLeftPos(zoom){
            var left=(zoomController.width()*(zoom))/23;
            zoomControllerChanger.css('left',left);
            console.log(getZoom(left));
        }
        function checkRange(){
            if(self.mapZoom<0){
                self.mapZoom=0;
            }
            if(self.mapZoom>23){
                self.mapZoom=23;
            }
        }
        function getZoom(left){
            return Math.round(23*left/zoomController.width());
        }
    },
    getMarks:function($selector,$title){
        "use strict";
        var marks=[];
        $selector.each(function(){
            var coords=$(this).attr('data-sights-map-coords');
            coords=coords.split(',');
            var obj={
                name: $(this).find($title).text(),
                block: $(this),
                coords: coords
            };
            marks.push(obj);
        });
        return marks;
    }
};


window.citySights=new SightMap();
var LkMap= function(){
    "use strict";

};

LkMap.prototype={
  init: function(){
      "use strict";
      var self=this;
      self.markList=[];
      $('#lk-map').addClass('loading');
    this.getApi().then(
        function(){
            self.createMap();
        }
    );
  },
    getApi:function(){
        "use strict";
        var self=this;

        if(!window.ymaps){
            return new Promise(function(resolve, reject){
                var yApi=document.createElement('script');
                yApi.type='text/javascript';
                document.body.appendChild(yApi);
                yApi.src='https://api-maps.yandex.ru/2.1/?lang=ru_RU';
                yApi.addEventListener('load',function(){
                    "use strict";
                    resolve();
                },false);
            });
        } else {
            self.createMap();
            return true;
        }
    },
    createMap:function(){
        "use strict";
        var self=this;
        ymaps.ready(function () {
            self.mapZoom=10;
            var lat =43.730502;
            var lng =39.729450;
            self.sightMap = new window.ymaps.Map('lk-map', {
                    center: [lat, lng],
                    zoom: self.mapZoom
                },
                {
                    maxZoom:20,
                    minZoom: 8
                });
            self.sightMap.behaviors.disable('scrollZoom');
            if(detectMob()){
                self.sightMap.behaviors.disable('drag');
            }
            self.addMarks(self.sightMap,self.getCords(),
                {
                    iconLayout: 'default#image',
                    iconImageHref: 'http://localhost:3000/img/marker_map_lk.png', // картинка иконки
                    iconImageSize: [24, 29], // размеры картинки
                    iconImageOffset: [-12, -14] // смещение картинки

                },false);
            self.setActiveMark();
        });
        $('#lk-map').removeClass('loading');

    },
    addMarks: function(map,marks,markImgOptions,addEvent){
        var self=this;
        for(var i=0;i<marks.length; i++){
            var obj=marks[i];
            var newMark = new window.ymaps.Placemark(obj.data,{
                    hintContent: obj.title,
                    balloonContent: obj.title,
                    iconCaption: obj.title
                },
                markImgOptions
            );
            if(addEvent){

            }
            self.markList.push({
                selector:$('[data-coords="'+obj.data+'"]'),
                mark: newMark
            });

            map.geoObjects.add(newMark);
        }
    },
    getCords: function(){
        "use strict";

        var coords=[];
        var selector=$('[data-coords]');
        selector.each(function(){
            coords.push(
                {
                    title: $(this).html(),
                    data: $(this).attr('data-coords').split(',')
                }
            );
        });
        return coords;
    },
    setActiveMark: function(){
        "use strict";
        var self=this;
        $('[data-coords]').on('click',function(){
            resetSize();
           var marker=findMarker($(this));
            marker.mark.options.set('iconImageSize', [35, 45]);
            marker.mark.options.set('iconImageOffset', [-17, -22]);
        });

        addEventToMarkers();

        function findMarker(selector){
            for(var i=0;i<self.markList.length;i++){
                var current=self.markList[i];
                if(current.selector[0]===selector[0]){
                    return current;
                }
            }
        }
        function resetSize(){
            for(var i=0;i<self.markList.length;i++){
                var current=self.markList[i];
                current.mark.options.set('iconImageSize', [24, 29]);
                current.mark.options.set('iconImageOffset', [-11, -14]);
            }
        }
        function addEventToMarkers(){
            self.sightMap.geoObjects.events.add('click', function (e) {
                var object = e.get('target');
                var selStr='[data-coords="'+object.geometry._coordinates+'"]';
                var selector=$('.city-m').find(selStr);
                if(!selector.closest('.accord-block-item').hasClass('active')){
                    selector.trigger('click');
                }
               $('html, body').animate({scrollTop:  selector.offset().top-300},800);
            });
        }
    }
};

if($('#lk-map').length){
    window.lkMap= new LkMap();
    window.lkMap.init();
}
"use strict";